import React from 'react';

type Props = {
  text?: string;
  id?: string;
};

const ErrorAlert: React.FC<Props> = ({ text, id }) => {
  if (!text) return null;
  return (
    <div role="alert" aria-live="assertive" id={id} className="bg-red-50 border border-red-100 rounded-2xl p-4 flex items-center gap-3 animate-shake">
      <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0 text-red-500">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <p className="text-sm font-bold text-red-600">{text}</p>
    </div>
  );
};

export default ErrorAlert;
